import { createContext, type ReactNode } from 'react';

/**
 * Slots exposed by an artifact's detail content to the unified SlidePanel
 * shell. The content component calls `useRegisterDetailSlots` on mount to
 * publish its header, toolbar callbacks, and panel preferences; the shell
 * reads them via `useDetailOverlaySlots`.
 */
export interface DetailOverlaySlots {
  headerContent?: ReactNode;
  onEdit?: () => void;
  onDelete?: () => void;
  fullscreenWideContent?: boolean;
  defaultFullscreen?: boolean;
  previewMode?: boolean;
  onPreviewModeChange?: (mode: boolean) => void;
}

export interface DetailOverlayContextValue {
  slots: DetailOverlaySlots;
  setSlots: (slots: DetailOverlaySlots) => void;
  isFullscreenMode: boolean;
  setIsFullscreenMode: (next: boolean) => void;
}

export const EMPTY_SLOTS: DetailOverlaySlots = {};

export const DetailOverlayContext =
  createContext<DetailOverlayContextValue | null>(null);
